import React from 'react';

import styled from '@emotion/styled';

import { IconProps } from '../../IconsProps';

const StyledFeedback = styled.svg<IconProps>`
  & .cls-1,
  .cls-2,
  .cls-3 {
    fill: none;
  }

  & .cls-3 {
    stroke: var(--chatbot-color-primary, #404040);
  }

  & .cls-4,
  .cls-5 {
    stroke: none;
  }

  & .cls-5 {
    fill: var(--chatbot-color-primary, #404040);
  }

  &: hover, &.active {
    .cls-1,
    .cls-3 {
      fill: none;
    }

    .cls-2 {
      fill: var(--du-color-primary, #128370);
    }

    .cls-3 {
      stroke: #fff;
    }

    .cls-4,
    .cls-5 {
      stroke: none;
    }

    .cls-5 {
      fill: var(--du-color-primary, #128370);
    }
  }
`;

const FeedbackIcon: React.FC<IconProps> = props => {
  const activeClass = props.active ? 'active' : undefined;
  return (
    <StyledFeedback
      id='Feedback-Icon'
      xmlns='http://www.w3.org/2000/svg'
      width='32'
      height='32'
      viewBox='0 0 32 32'
      className={activeClass}
    >
      <rect id='Margin' className='cls-1' width='32' height='32' />
      <g id='Icon' transform='translate(4 3.499)'>
        <g
          id='Icon_material-feedback'
          data-name='Icon material-feedback'
          className='cls-2'
          transform='translate(1 1.501)'
        >
          <path
            className='cls-4'
            d='M17.4,3H4.6A1.6,1.6,0,0,0,3.008,4.6L3,19l3.2-3.2H17.4A1.6,1.6,0,0,0,19,14.2V4.6A1.6,1.6,0,0,0,17.4,3Z'
          />
          <path
            className='cls-5'
            d='M 4.600000381469727 4 C 4.273569107055664 4 4.007999420166016 4.269159317016602 4.007999420166016 4.600559234619141 L 4.0013427734375 16.58443832397461 L 5.785789489746094 14.80000019073486 L 17.39999961853027 14.80000019073486 C 17.7252311706543 14.80000019073486 18 14.52523040771484 18 14.19999980926514 L 18 4.600000381469727 C 18 4.274770736694336 17.7252311706543 4 17.39999961853027 4 L 4.600000381469727 4 M 4.600000381469727 3 L 17.39999961853027 3 C 18.28000068664551 3 19 3.719999313354492 19 4.600000381469727 L 19 14.19999980926514 C 19 15.07999992370605 18.28000068664551 15.80000019073486 17.39999961853027 15.80000019073486 L 6.199999809265137 15.80000019073486 L 3 19 L 3.007999420166016 4.600000381469727 C 3.007999420166016 3.719999313354492 3.719999313354492 3 4.600000381469727 3 Z'
          />
        </g>
        <g id='Group_17470' data-name='Group 17470' transform='translate(1.696 0.783)'>
          <line id='Line_394' data-name='Line 394' className='cls-3' x2='9.609' transform='translate(5.5 8.001)' />
          <line id='Line_395' data-name='Line 395' className='cls-3' x2='9.609' transform='translate(5.5 10.218)' />
          <line id='Line_396' data-name='Line 396' className='cls-3' x2='7.391' transform='translate(5.5 12.436)' />
        </g>
      </g>
    </StyledFeedback>
  );
};

export default FeedbackIcon;
